// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.5_@swc+helpers@0.5.11__webpack@5.101.3_@swc+core@1.4.17_@swc+helpers@0.5.11__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.5_@swc+helpers@0.5.11__webpack@5.101.3_@swc+core@1.4.17_@swc+helpers@0.5.11__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.pages-error {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 15vh;
  min-height: 600px;
}
.pages-error .image-container {
  flex: 1;
  padding-right: 30px;
}
.pages-error .image-container::before,
.pages-error .image-container::after {
  content: ' ';
  display: table;
}
.pages-error .image-container::after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.pages-error .image-container .image {
  height: 400px;
  width: 100%;
  max-width: 480px;
  float: right;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
}
.pages-error .description-container {
  flex: 1;
  padding-right: 40px;
}
.pages-error .description-container h1 {
  color: #434e59;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 24px;
}
.pages-error .description-container .desc {
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 24px;
}
.pages-error .description-container .actions {
  display: flex;
  gap: 16px;
}
.pages-error .description-container .actions .ant-btn {
  height: 40px;
  padding: 0 24px;
  font-size: 16px;
}
@media screen and (max-width: 1200px) {
  .pages-error .image-container {
    padding-right: 30px;
  }
}
@media screen and (max-width: 576px) {
  .pages-error {
    display: block;
    text-align: center;
  }
  .pages-error .image-container {
    padding-right: 0;
    margin: 0 auto 24px;
  }
}
@media screen and (max-width: 480px) {
  .pages-error .image-container {
    margin-bottom: -24px;
    overflow: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/error/index.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAD7F;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;AAGF;AARA;EAQI,OAAA;EACA,mBAAA;AAGJ;AADI;;EAEE,YAAA;EACA,cAAA;AAGN;AAAI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AAEN;AAvBA;EAyBM,aAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,4BAAA;EACA,4BAAA;EACA,wBAAA;AACN;AAhCA;EAoCI,OAAA;EACA,mBAAA;AADJ;AApCA;EAwCM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AADN;AA3CA;EAgDM,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAjDA;EAuDM,aAAA;EACA,SAAA;AAHN;AArDA;EA2DQ,YAAA;EACA,eAAA;EACA,eAAA;AAHR;AASA;EACE;IAEI,mBAAA;EARJ;AACF;AAYA;EACE;IACE,cAAA;IACA,kBAAA;EAVF;EAQA;IAKI,gBAAA;IACA,mBAAA;EAVJ;AACF;AAcA;EACE;IAEI,oBAAA;IACA,gBAAA;EAbJ;AACF","sourcesContent":["@import '../../../../../../node_modules/antd/lib/style/themes/default.less';\n\n.pages-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 15vh;\n  min-height: 600px;\n\n  .image-container {\n    flex: 1;\n    padding-right: 30px;\n\n    &::before,\n    &::after {\n      content: ' ';\n      display: table;\n    }\n\n    &::after {\n      clear: both;\n      visibility: hidden;\n      font-size: 0;\n      height: 0;\n    }\n\n    .image {\n      height: 400px;\n      width: 100%;\n      max-width: 480px;\n      float: right;\n      background-repeat: no-repeat;\n      background-position: 50% 50%;\n      background-size: contain;\n    }\n  }\n\n  .description-container {\n    flex: 1;\n    padding-right: 40px;\n\n    h1 {\n      color: #434e59;\n      font-size: 48px;\n      font-weight: 600;\n      line-height: 1.2;\n      margin-bottom: 24px;\n    }\n\n    .desc {\n      color: @text-color-secondary;\n      font-size: 20px;\n      line-height: 1.5;\n      margin-bottom: 24px;\n    }\n\n    .actions {\n      display: flex;\n      gap: 16px;\n\n      .ant-btn {\n        height: 40px;\n        padding: 0 24px;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: @screen-xl) {\n  .pages-error {\n    .image-container {\n      padding-right: 30px;\n    }\n  }\n}\n\n@media screen and (max-width: @screen-sm) {\n  .pages-error {\n    display: block;\n    text-align: center;\n\n    .image-container {\n      padding-right: 0;\n      margin: 0 auto 24px;\n    }\n  }\n}\n\n@media screen and (max-width: @screen-xs) {\n  .pages-error {\n    .image-container {\n      margin-bottom: -24px;\n      overflow: hidden;\n    }\n  }\n}\n\n@badge-height: 16px;@badge-font-size: 9.6px;@fill-body: #FFFFFF;@menu-collapsed-width: 64px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
